(function () {
  const section_instances = new Map();
  const CONTENT_WIDTH = 1200;

  function destroy_section(section_id) {
    const entry = section_instances.get(section_id);
    if (!entry) return;
    if (entry.resize_handler) {
      window.removeEventListener("resize", entry.resize_handler);
    }
    if (entry.swiper) {
      entry.swiper.destroy(true, true);
    }
    section_instances.delete(section_id);
  }

  function parse_slides(value, fallback) {
    if (String(value).toLowerCase() === "auto") return "auto";
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function get_side_offset(section_el) {
    const is_mobile = window.matchMedia("(max-width: 767px)").matches;
    if (is_mobile) {
      return Number(section_el.dataset.offsetM || 15);
    }
    return Math.max(16, (window.innerWidth - CONTENT_WIDTH) / 2);
  }

  function visible_count(slides_per_view) {
    if (slides_per_view === "auto") return 4;
    return slides_per_view;
  }

  function update_thumb(entry, immediate) {
    const thumb_el = entry.thumb_el;
    const swiper = entry.swiper;
    if (!thumb_el || !swiper) return;

    const count = entry.slide_count;
    if (count < 1) return;

    let ratio;
    if (count === 1) {
      ratio = 1;
    } else if (swiper.params.loop) {
      ratio = (((swiper.realIndex || 0) % count) + 1) / count;
    } else {
      ratio = (swiper.progress * (count - 1) + 1) / count;
    }

    ratio = Math.min(1, Math.max(1 / count, ratio));
    thumb_el.style.transition = immediate ? "none" : "";
    thumb_el.style.width = ratio * 100 + "%";
  }

  function apply_offset(entry) {
    if (!entry || !entry.swiper) return;
    const offset = get_side_offset(entry.section_el);
    entry.swiper.params.slidesOffsetBefore = offset;
    if (entry.swiper.params.breakpoints && entry.swiper.params.breakpoints[768]) {
      entry.swiper.params.breakpoints[768].slidesOffsetBefore = offset;
    }
    entry.swiper.update();
  }

  function create_section(section_el) {
    if (typeof window.Swiper !== "function") return;

    const section_id = section_el.dataset.sectionId;
    if (!section_id) return;

    destroy_section(section_id);

    const swiper_el = section_el.querySelector("[data-mmc-swiper]");
    if (!swiper_el) return;

    const enable_loop = section_el.dataset.loop === "true";
    const enable_autoplay = section_el.dataset.autoplay === "true";
    const autoplay_delay = Math.max(1, Number(section_el.dataset.autoplayDelay || 5)) * 1000;
    const space_between = Number(section_el.dataset.space || 12);
    const space_between_m = Number(section_el.dataset.spaceM || 6);
    const speed = Number(section_el.dataset.speed || 600);
    const initial_slide = Number(section_el.dataset.initial || 0);
    const slides_per_view = parse_slides(section_el.dataset.slides, "auto");
    const slides_per_view_m = parse_slides(section_el.dataset.slidesM, "auto");
    const reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const offset = get_side_offset(section_el);

    const original_slides = Array.from(swiper_el.querySelectorAll(".mz01-mc__slide"));
    const slide_count = original_slides.length;
    if (slide_count === 0) return;

    const prev_el = section_el.querySelector("[data-mmc-prev]");
    const next_el = section_el.querySelector("[data-mmc-next]");
    const thumb_el = section_el.querySelector("[data-mmc-thumb]");
    const loop_enabled = enable_loop && slide_count > 1;

    if (loop_enabled) {
      const wrapper_el = swiper_el.querySelector(".swiper-wrapper");
      const min_slides = Math.ceil(Math.max(visible_count(slides_per_view), visible_count(slides_per_view_m)) * 2);
      let guard = 0;
      while (wrapper_el.querySelectorAll(".mz01-mc__slide").length < min_slides && guard < 6) {
        original_slides.forEach(function (slide_el) {
          const clone_el = slide_el.cloneNode(true);
          clone_el.removeAttribute("data-shopify-editor-block");
          wrapper_el.appendChild(clone_el);
        });
        guard += 1;
      }
    }

    const swiper = new window.Swiper(swiper_el, {
      slidesPerView: slides_per_view_m,
      centeredSlides: false,
      loop: loop_enabled,
      loopAdditionalSlides: loop_enabled ? slide_count : 0,
      speed: reduce_motion ? 0 : speed,
      grabCursor: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      initialSlide: initial_slide,
      spaceBetween: space_between_m,
      slidesOffsetBefore: offset,
      breakpoints: {
        768: {
          slidesPerView: slides_per_view,
          centeredSlides: false,
          spaceBetween: space_between,
          slidesOffsetBefore: offset
        }
      },
      autoplay:
        enable_autoplay && !reduce_motion
          ? {
              delay: autoplay_delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
      navigation:
        prev_el && next_el
          ? { prevEl: prev_el, nextEl: next_el, disabledClass: "swiper-button-disabled" }
          : false,
      on: {
        init: function () {
          update_thumb({ swiper: this, thumb_el: thumb_el, slide_count: slide_count });
        },
        slideChange: function () {
          update_thumb({ swiper: this, thumb_el: thumb_el, slide_count: slide_count });
        },
        sliderMove: function () {
          update_thumb({ swiper: this, thumb_el: thumb_el, slide_count: slide_count }, true);
        }
      }
    });

    let resize_timer = null;
    const resize_handler = function () {
      window.clearTimeout(resize_timer);
      resize_timer = window.setTimeout(function () {
        const entry = section_instances.get(section_id);
        apply_offset(entry);
      }, 150);
    };
    window.addEventListener("resize", resize_handler, { passive: true });

    section_instances.set(section_id, {
      swiper: swiper,
      section_el: section_el,
      thumb_el: thumb_el,
      slide_count: slide_count,
      resize_handler: resize_handler
    });
  }

  function init_all_sections() {
    document.querySelectorAll("[data-mmc-section]").forEach(function (section_el) {
      create_section(section_el);
    });
  }

  function wait_for_swiper(retry) {
    retry = retry || 0;
    if (typeof window.Swiper === "function") {
      init_all_sections();
      return;
    }
    if (retry > 20) return;
    setTimeout(function () {
      wait_for_swiper(retry + 1);
    }, 120);
  }

  document.addEventListener("DOMContentLoaded", function () {
    wait_for_swiper();
  });

  document.addEventListener("shopify:section:load", function (event) {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-mmc-section]") : null;
    if (!section_el) return;
    create_section(section_el);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-mmc-section]") : null;
    if (!section_el) return;
    destroy_section(section_el.dataset.sectionId);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const slide_el =
      event.target && event.target.closest ? event.target.closest(".mz01-mc__slide") : null;
    if (!slide_el) return;
    const section_el = slide_el.closest("[data-mmc-section]");
    if (!section_el) return;
    const entry = section_instances.get(section_el.dataset.sectionId);
    if (!entry || !entry.swiper) return;

    if (typeof slide_el.dataset.swiperSlideIndex !== "undefined") {
      entry.swiper.slideToLoop(Number(slide_el.dataset.swiperSlideIndex));
    } else {
      const index = Array.prototype.indexOf.call(slide_el.parentNode.children, slide_el);
      entry.swiper.slideTo(index);
    }
  });
})();
